import React, { useState, useEffect } from "react";

export default function ShippingForm({ selectedAddress }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
  });
  const [isBillingSame, setIsBillingSame] = useState(true);
  const [billingForm, setBillingForm] = useState({ ...form });
  const [errors, setErrors] = useState({});
  const [billingErrors, setBillingErrors] = useState({});
  const isDisabled = !!selectedAddress;
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error while typing
  };

  const handleSave = () => {
    const newErrors = {};
    const newBillingErrors = {};

    // 🔹 Shipping validation
    if (!form.firstName) newErrors.firstName = "Enter your first name";
    if (!form.lastName) newErrors.lastName = "Enter your last name";
    if (!form.email) newErrors.email = "Enter your email address";
    if (!form.address) newErrors.address = "Enter your address";
    if (!form.pincode) newErrors.pincode = "Enter your pincode";
    if (!form.city) newErrors.city = "Enter your city";
    if (!form.state) newErrors.state = "Enter your state";
    if (!form.country) newErrors.country = "Enter your country";

    // 🔹 Billing validation ONLY if checkbox unchecked
    if (!isBillingSame) {
      if (!billingForm.firstName)
        newBillingErrors.firstName = "Enter your first name";
      if (!billingForm.lastName)
        newBillingErrors.lastName = "Enter your last name";
      if (!billingForm.email)
        newBillingErrors.email = "Enter your email address";
      if (!billingForm.address) newBillingErrors.address = "Enter your address";
      if (!billingForm.pincode) newBillingErrors.pincode = "Enter your pincode";
      if (!billingForm.city) newBillingErrors.city = "Enter your city";
      if (!billingForm.state) newBillingErrors.state = "Enter your state";
      if (!billingForm.country) newBillingErrors.country = "Enter your country";
    }

    setErrors(newErrors);
    setBillingErrors(newBillingErrors);

    if (
      Object.keys(newErrors).length === 0 &&
      Object.keys(newBillingErrors).length === 0
    ) {
      console.log("Shipping:", form);
      console.log("Billing:", isBillingSame ? form : billingForm);
    }
  };
  useEffect(() => {
    if (isBillingSame) {
      setBillingForm(form);
    }
  }, [form, isBillingSame]);
  useEffect(() => {
    if (selectedAddress) {
      const [firstName = "", lastName = ""] =
        selectedAddress.name?.split(" ") || [];

      setForm({
        firstName,
        lastName,
        email: selectedAddress.email || "",
        phone: selectedAddress.phone || "", // ✅ now works
        address: selectedAddress.addressLine || "",
        pincode: selectedAddress.pincode || "",
        city: selectedAddress.city || "",
        state: selectedAddress.state || "",
        country: selectedAddress.country || "",
      });
    }
  }, [selectedAddress]);
  return (
    <div className="bg-[#ffffff] rounded-xl p-6">
      <h3 className="font-semibold font-lexend text-[#333333] text-[20px] mb-4">
        Shipping
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 font-lexend font-light">
        {/* First Name */}
        <div className="flex flex-col">
          <input
            name="firstName"
            value={form.firstName}
            disabled={isDisabled}
onChange={!isDisabled ? handleChange : undefined}
            placeholder="First name *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.firstName
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.firstName && (
            <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>
          )}
        </div>

        {/* Last Name */}
        <div className="flex flex-col">
          <input
            name="lastName"
            value={form.lastName}
            disabled={isDisabled}
            onChange={!isDisabled ? handleChange : undefined}
            placeholder="Last name *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.lastName
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.lastName && (
            <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>
          )}
        </div>

        {/* Email */}
        <div className="flex flex-col md:col-span-2">
          <input
            name="email"
            value={form.email}
            disabled={isDisabled}
onChange={!isDisabled ? handleChange : undefined}
            placeholder="Email address *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.email
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
          )}
        </div>

        {/* Address */}
        <div className="flex flex-col md:col-span-2">
          <input
            name="address"
            value={form.address}
            disabled={isDisabled}
onChange={!isDisabled ? handleChange : undefined}
            placeholder="Address *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.address
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.address && (
            <p className="text-red-500 text-sm mt-1">{errors.address}</p>
          )}
        </div>

        {/* Address Line 2 (optional → no validation) */}
        <input
          placeholder="Address line two"
          className="border rounded-md px-4 py-2 text-[18px]
    focus:outline-none focus:border-[#2f5d3a] focus:ring-1 focus:ring-[#2f5d3a] md:col-span-2"
        />

        {/* Pincode */}
        <div className="flex flex-col">
          <input
            name="pincode"
            value={form.pincode}
            disabled={isDisabled}
onChange={!isDisabled ? handleChange : undefined}
            placeholder="Pincode *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.pincode
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.pincode && (
            <p className="text-red-500 text-sm mt-1">{errors.pincode}</p>
          )}
        </div>

        {/* City */}
        <div className="flex flex-col">
          <input
            name="city"
            value={form.city}
            disabled={isDisabled}
onChange={!isDisabled ? handleChange : undefined}
            placeholder="City *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.city
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.city && (
            <p className="text-red-500 text-sm mt-1">{errors.city}</p>
          )}
        </div>

        {/* State */}
        <div className="flex flex-col">
          <input
            name="state"
            value={form.state}
            disabled={isDisabled}
onChange={!isDisabled ? handleChange : undefined}
            placeholder="State *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.state
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.state && (
            <p className="text-red-500 text-sm mt-1">{errors.state}</p>
          )}
        </div>

        {/* Country */}
        <div className="flex flex-col">
          <input
            name="country"
            value={form.country}
            disabled={isDisabled}
onChange={!isDisabled ? handleChange : undefined}
            placeholder="Country *"
            className={`border rounded-md px-4 py-2 text-[18px]
      focus:outline-none focus:ring-1
      ${
        errors.country
          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
          : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
      }`}
          />
          {errors.country && (
            <p className="text-red-500 text-sm mt-1">{errors.country}</p>
          )}
        </div>
      </div>
      {!isBillingSame && (
        <div className="mt-6 border-t pt-6">
          <h3 className="font-semibold font-lexend text-[#333] text-[20px] mb-4">
            Billing Address
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 font-lexend font-light">
            {/* First Name */}
            <div className="flex flex-col">
              <input
                placeholder="First name *"
                value={billingForm.firstName}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, firstName: e.target.value });
                  setBillingErrors({ ...billingErrors, firstName: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.firstName ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.firstName && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.firstName}
                </p>
              )}
            </div>

            {/* Last Name */}
            <div className="flex flex-col">
              <input
                placeholder="Last name *"
                value={billingForm.lastName}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, lastName: e.target.value });
                  setBillingErrors({ ...billingErrors, lastName: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.lastName ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.lastName && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.lastName}
                </p>
              )}
            </div>

            {/* Email */}
            <div className="flex flex-col md:col-span-2">
              <input
                placeholder="Email address *"
                value={billingForm.email}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, email: e.target.value });
                  setBillingErrors({ ...billingErrors, email: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.email ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.email && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.email}
                </p>
              )}
            </div>

            {/* Address */}
            <div className="flex flex-col md:col-span-2">
              <input
                placeholder="Address *"
                value={billingForm.address}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, address: e.target.value });
                  setBillingErrors({ ...billingErrors, address: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.address ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.address && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.address}
                </p>
              )}
            </div>

            {/* Pincode */}
            <div className="flex flex-col">
              <input
                placeholder="Pincode *"
                value={billingForm.pincode}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, pincode: e.target.value });
                  setBillingErrors({ ...billingErrors, pincode: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.pincode ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.pincode && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.pincode}
                </p>
              )}
            </div>

            {/* City */}
            <div className="flex flex-col">
              <input
                placeholder="City *"
                value={billingForm.city}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, city: e.target.value });
                  setBillingErrors({ ...billingErrors, city: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.city ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.city && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.city}
                </p>
              )}
            </div>

            {/* State */}
            <div className="flex flex-col">
              <input
                placeholder="State *"
                value={billingForm.state}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, state: e.target.value });
                  setBillingErrors({ ...billingErrors, state: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.state ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.state && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.state}
                </p>
              )}
            </div>

            {/* Country */}
            <div className="flex flex-col">
              <input
                placeholder="Country *"
                value={billingForm.country}
                onChange={(e) => {
                  setBillingForm({ ...billingForm, country: e.target.value });
                  setBillingErrors({ ...billingErrors, country: "" });
                }}
                className={`border rounded-md px-4 py-2 text-[18px]
            ${billingErrors.country ? "border-red-500" : "border-gray-300"}`}
              />
              {billingErrors.country && (
                <p className="text-red-500 text-sm mt-1">
                  {billingErrors.country}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-6">
        {/* CHECKBOXES */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 font-lexend text-[16px] md:text-[18px] text-[#333]">
          <label className="flex items-center gap-2">
            <input type="checkbox" className="accent-[#2f5d3a]" />
            Make default address
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={isBillingSame}
              onChange={() => setIsBillingSame(!isBillingSame)}
              className="accent-[#2f5d3a]"
            />
            Billing address same as shipping address
          </label>
        </div>
        {/* SAVE BUTTON */}
        <button
          onClick={handleSave}
          className="bg-[#2f5d3a] font-semibold text-[#f4e391] px-6 py-2 rounded-lg font-lexend text-[18px] md:text-[22px] w-full md:w-auto"
        >
          Save
        </button>
      </div>
    </div>
  );
}
